import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { AgreementStatuses } from 'src/app/models/agreement-statuses/agreement-statuses';
import { PrivacyPolicyAggregate } from 'src/app/models/privacy-policy/privacy-policy-aggregate';
import { PrivacyPolicyUrl } from 'src/app/models/privacy-policy/privacy-policy-url';
import { PrivacyPolicyVersion } from 'src/app/models/privacy-policy/privacy-policy-version';
import { TermsOfServiceAggregate } from 'src/app/models/terms-of-service/terms-of-service-aggregate';
import { TermsOfServiceUrl } from 'src/app/models/terms-of-service/terms-of-service-url';
import { TermsOfServiceVersion } from 'src/app/models/terms-of-service/terms-of-service-version';
import { AgreementStatusesCommands } from './agreement-statuses.commands';
import { AgreementStatusesQueries } from './agreement-statuses.queries';
import { PrivacyPolicyViewModel } from './view-model/privacy-policy-view-model';
import { TermsOfServiceViewModel } from './view-model/terms-of-service-view-model';

@Component({
  selector: 'app-agreement-statuses',
  templateUrl: './agreement-statuses.component.html',
  styleUrls: ['./agreement-statuses.component.scss'],
})
export class AgreementStatusesComponent {
  privacyPolicy: PrivacyPolicyViewModel = new PrivacyPolicyViewModel(
    new PrivacyPolicyAggregate(),
  );
  termsOfService: TermsOfServiceViewModel = new TermsOfServiceViewModel(
    new TermsOfServiceAggregate(),
  );
  constructor(
    private readonly queries: AgreementStatusesQueries,
    private readonly commands: AgreementStatusesCommands,
  ) {
    this.queries.privacyPolicy$.pipe(take(1)).subscribe(privacyPolicy => {
      this.privacyPolicy = new PrivacyPolicyViewModel(privacyPolicy);
    });
    this.queries.termsOfService$.pipe(take(1)).subscribe(termsOfService => {
      this.termsOfService = new TermsOfServiceViewModel(termsOfService);
    });
  }

  async agreement() {
    this.commands.setAgreementStatuses(
      this.privacyPolicy.version,
      this.termsOfService.version,
    );
  }
}
